// extracted by mini-css-extract-plugin
export default {"day":"Stocks_day__eQfwQ","checkbox":"Stocks_checkbox__dV6Yw"};